// packages
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// local imports
import CustomModal from '../../components/molecules/CustomModal';
import CustomTable from '../../components/molecules/CustomTable';
import { COLUMNS } from './constants';
import Footer from '../../components/organisms/Footer';
import GlobalFilter from '../../components/molecules/CustomTable/GlobalFilter';
import CustomSpinner from '../../components/atoms/CustomSpinner';
import editIcon from '../../assets/icon-edit.svg';
import trashIcon from '../../assets/icon-delete.svg';
import eyeIconShow from '../../assets/eye-icon-show.svg';
import { useNavigate, useLocation } from 'react-router';
import { appActions } from '../../store/slices/app';
import { EnamelPaintingService, WorkOrderService } from '../../service';
import { workOrderFormActions } from '../../store/slices';

function FormTracking({ title, route }) {
    const { state } = useLocation();
    const [formType, setFormType] = useState(state?.formType || "workOrderType")
    const navigate = useNavigate();
    const isLoading = useSelector((state) => state.app.isLoading);
    const [forms, setForms] = useState();
    const dispatch = useDispatch();
    const tableInstance = useRef(null);

    const [fetchTrigger, setFetchTrigger] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [deleteItem, setDeleteItem] = useState(null);

    useEffect(() => {
        const requestOnFormType = formType === 'enamelType' ? EnamelPaintingService.getEnamelPaintingsService : WorkOrderService.getWorkOrdersService
        const fetchForms = async () => {
            dispatch(appActions.setLoading(true));
            try {
                const data = await requestOnFormType();
                setForms(data)
                await WorkOrderService.getWorkOrderCounter();
                dispatch(workOrderFormActions.setWorkOrderForm(data));
            } catch (error) {
                console.log(error)
            } finally {
                dispatch(appActions.setLoading(false));
            }
        };

        fetchForms();
    }, [fetchTrigger, formType])

    const handleDelete = async (id) => {
        const requestOnFormType = formType === 'enamelType' ? EnamelPaintingService.deleteEnamelPaintings : WorkOrderService.deleteWorkOrders
        try {
            dispatch(appActions.setLoading(true));
            const data = await requestOnFormType(id);
            setFetchTrigger(!fetchTrigger);
        } catch (err) {
            console.log(err);
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }

    const handleType = (e) => {
        const { name } = e.target

        setFormType(name)
    }

    const ICONS = [
        {
            id: 1,
            image: eyeIconShow,
            onClick: (id) => {
                if(formType === 'enamelType'){
                    navigate(`/factory/view-enamel-painting-work-order/${id}`)
                    return
                }
                navigate(`/factory/view-work-order/${id}`)
            }
        },
        // {
        //     id: 2,
        //     image: editIcon,
        //     onClick: async (id) => {
        //         console.log(id)
        //         navigate(`/factory/edit-product/${id}`)
        //     },
        //     disable: true,
        // },
        {
            id: 3,
            image: trashIcon,
            onClick: async (id) => {
                setDeleteItem(id);
                setModalShow(true);
            }
        },
    ]

    const MODAL_BUTTONS = [
        {
            name: 'İptal',
            variant: 'primary',
            onClick: () => setModalShow(false)
        },
        {
            name: 'Evet',
            variant: 'light',
            onClick: () => {
                handleDelete(deleteItem)
                setModalShow(false)
            }
        }
    ]
    return (
        <>
            <div className='product-list-container main-container padding-vertical-80'>
                <div className="product-list-header">
                    <h2>
                        {title}
                        {isLoading && <CustomSpinner className="ms-2 " />}
                    </h2>
                    <div className='form-tracking-filter'>
                        <div className='filter-by-type'>
                            <input type="radio" id="work-order-type" name="workOrderType" onChange={(e) => handleType(e)} checked={formType === 'workOrderType'} />
                            <label htmlFor="work-order-type">İş Emri</label><br></br>
                        </div>
                        <div className='filter-by-type'>
                            <input type="radio" id="enamel-type" name="enamelType" onChange={(e) => handleType(e)} checked={formType === 'enamelType'} />
                            <label htmlFor="enamel-type">Emaye</label><br></br>
                        </div>
                        <GlobalFilter tableInstance={tableInstance} placeholder={'Form ara..'} />
                    </div>
                </div>
                {
                    forms &&
                    <CustomTable
                        tableColumns={COLUMNS}
                        tableData={forms}
                        tableRow={4}
                        ref={tableInstance}
                        searchBar
                        icons={ICONS}
                        workOrder
                    />
                }
            </div>
            <Footer backButton />
            <CustomModal
                title={'İş Emri Sil'}
                message={'İş emrini silmek istediğinden emin misin?'}
                buttons={
                    MODAL_BUTTONS
                }
                onOk={modalShow}
                onClose={() => setModalShow(false)}
            />
        </>
    );
}
export default FormTracking;